import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export namespace OnlyFansStatisticsTodayActivitySummary {
    export interface Response {
        stories: number;
        posts: number;
        chats: number;
        streams: number;
    }
}

const useSubscriberStatsTodayActivitySummary = (subscriberId: string | undefined) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchData = async (): Promise<OnlyFansStatisticsTodayActivitySummary.Response | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId) {
            return null;
        }

        const query = `${settingsContext.routes.onlyFans.base}${subscriberId}/stats/today-activity`;

        return axios
            .get(query)
            .then(response => response.data as OnlyFansStatisticsTodayActivitySummary.Response)
            .catch(error => {
                handleHttpError(error, dialog);

                return null;
            });
    };

    return useQuery(['subscriberStatsTodayActivitySummary', subscriberId], fetchData, {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        enabled: !!(userContext.jwtToken && settingsContext.apiKey && subscriberId),
    });
};

export default useSubscriberStatsTodayActivitySummary;
